import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { formatWohnform } from '@/lib/formatUtils';
import { WOHNFORM_OPTIONS, normalisiereWohnform } from '@/lib/wohnform';

// ===== Wohnform: eine Quelle (klient.wohnform), ein Katalog (lib/wohnform.js) =====
// Paket A: KEINE Verguetungseinordnung/-hinweise, solange die Verguetungsberechnung nicht vereinheitlicht ist.
// Bestehende Werte bleiben unveraendert: gespeichert wird nur, wenn die Auswahl aktiv geaendert wird (editData enthaelt nur geaenderte Felder);
// ein Altwert ausserhalb des Katalogs bleibt sichtbar und waehlbar.
export default function WohnformFeld({ klient, editMode, editData, setEditData }) {
  const aktuell = { ...klient, ...(editData || {}) };
  const roh = aktuell.wohnform;
  const w = normalisiereWohnform(roh);
  if (editMode) {
    const imKatalog = !w || WOHNFORM_OPTIONS.some(o => o.value === w);
    const wert = !w ? 'nicht_angegeben' : (imKatalog ? w : String(roh));
    return (
      <div>
        <label className="text-xs text-slate-500">Wohnform</label>
        <Select value={wert} onValueChange={v => setEditData(prev => ({ ...prev, wohnform: v }))}>
          <SelectTrigger className="mt-1" data-testid="bereich-input-wohnform"><SelectValue /></SelectTrigger>
          <SelectContent>
            {!imKatalog && <SelectItem value={String(roh)}>{String(roh)} (bisheriger Eintrag)</SelectItem>}
            {WOHNFORM_OPTIONS.map(o => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    );
  }
  return (
    <div data-testid="bereich-feld-wohnform">
      <p className="text-xs text-slate-400">Wohnform</p>
      <p className={`font-medium ${w ? 'text-slate-800' : 'text-amber-600'}`}>
        {w ? formatWohnform(roh) : 'Offen – nicht aus der Anschrift ableitbar, bitte klären'}
      </p>
    </div>
  );
}
